module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "savebtn",
    staticStyle: {
      "text-align": "center",
      "position": "absolute",
      "bottom": "40px",
      "left": "0",
      "right": "0"
    }
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'DakejianCertSearch',
        query: {}
      }),
      expression: "{name:'DakejianCertSearch',query:{}}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("下载证书\n          ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.go()
      }
    }
  }, [_vm._v("活动专题\n          ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230425/user-0/20230425/a1bd4950e71614d8d809ed975938d3a0.jpeg?x-oss-process=style/tb-750"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e5f9073","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Dakejian.vue
// module id = 2300
// module chunks = 0